<template>
  <div :class="themeModel || 'theme-dark'">
    <v-app>
      <router-view id="routerView" />
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import Highcharts from "highcharts";
import defaultViewSettings from "@/domain/view_settings/data";
import More from "highcharts/highcharts-more";
import Annot from "highcharts/modules/annotations";
import nodata from "highcharts/modules/no-data-to-display";
More(Highcharts);
Annot(Highcharts);
nodata(Highcharts);
Highcharts.theme = {
  colors: [
    "#516DDC",
    "#FFBC42",
    "#E07A5F",
    "#BA68C8",
    "#3DDC97",
    "#FFD93D",
    "#4DD0E1",
    "#F28585",
    "#82AAFF",
    "#80ED99",
  ],
  chart: {
    backgroundColor: "var(--color-bg)",
    style: {
      fontFamily: "Roboto,\"Open Sans\",sans-serif",
    },
  },
  xAxis: {
    labels: {
      style: {
        color: "var(--color-text)",
        font: "12px Roboto",
      },
    },
    title: {
      style: {
        color: "var(--color-text)",
        font: "10px Roboto",
      },
    },
  },
  yAxis: {
    gridLineColor: "var(--grid-line-color)",
    gridLineWidth: 1,
    labels: {
      style: {
        color: "var(--color-text)",
        font: "12px Roboto",
      },
    },
    title: {
      style: {
        color: "var(--color-text)",
        font: "10px Roboto",
      },
    },
  },
  legend: {
    itemStyle: {
      font: "10px Roboto",
      color: "var(--color-text)",
    },
    itemHoverStyle: {
      color: "var(--color-primary)",
    },
  },
};

Highcharts.setOptions(Highcharts.theme);

export default {
  name: "App",
  computed: {
    ...mapState("main", ["theme"]),
    ...mapState(["viewSettings"]),
    ...mapState("notifications"),

    themeModel: {
      get() {
        return `theme-${this.theme}`;
      },
      set(value) {
        this.$store.commit("main/SET_THEME", value);
      },
    },
  },
  async created() {
    if (this.$msal.isAuthenticated) {
      const accessToken = await this.$msal.acquireToken();
      localStorage.setItem("quad_token", accessToken);
      // this.$router.push("/");
    } else {
      this.$router.push({ name: "login" });
    }
    axios.get("/config.json").then(async (response) => {
      const config = response.data;
      this.fetchApiUrls(config);
    });

    if (defaultViewSettings.usesWeatherTiles) {
      this.fetchTheyrAuthentication();
    }
    this.setUpFleet();
  },
  methods: {
    ...mapActions(["fetchApiUrls"]),
    async fetchTheyrAuthentication() {
      try {
        await this.$store.dispatch("weatherRouting/postAuthentication");
      } catch (e) {
        localStorage.setItem("theyr_token", null);
        localStorage.setItem("theyr_refresh_token", null);
      }
    },
    async setUpFleet() {
      const fleet = await this.$store.dispatch("main/fetchFleet");
      // const infoDetails = await this.$store.dispatch("main/fetchInfoDetails");
      //const notifications = await this.$store.dispatch("notifications/fetchNotifications");

      if (this.$route.params.vessel) {
        const vessel = fleet.find(
          (vessel) => vessel.vessel === this.$route.params.vessel
        );

        this.$store.commit("main/SET_SELECTED_VESSEL", vessel);
      }
    },
  },
};
</script>

<style>
@import "./assets/quadStyle.css";
@import "./assets/theme.css";

#routerView {
  width: 100%;
  height: 100%;

}
</style>
